import Swiper from 'swiper/bundle';
import { CountUp } from 'countup.js';

document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.home-hero-slider', {
    loop: true,
    speed: 1000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    on: {
      slideChange: function () {
        const bullets = document.querySelectorAll('.slider-nav .nav-bullet');
        bullets.forEach((bullet, index) => {
          bullet.classList.toggle('active', index === this.realIndex);
        });

        // Animate numbers in the active slide
        const activeSlide = document.querySelector(`.home-hero-slider .hero-slide:nth-of-type(${this.realIndex + 1})`);
        const numbers = activeSlide.querySelectorAll('.stat .number');
        numbers.forEach((numberElement) => {
          let targetValue = numberElement.getAttribute('data-stat-number');
          // bail if the value is not a number
          if (isNaN(targetValue)) { return; }
          targetValue = parseFloat(targetValue);
          const countUp = new CountUp(numberElement, targetValue);
          if (!countUp.error) {
            countUp.start();
          } else {
            console.error(countUp.error);
          }
        });
      },
    },
  });

  const bullets = document.querySelectorAll('.slider-nav .nav-bullet');
  const prevArrow = document.querySelector('.slider-nav .prev');
  const nextArrow = document.querySelector('.slider-nav .next');

  // Event listeners for navigation
  bullets.forEach((bullet, index) => {
    bullet.addEventListener('click', () => {
      swiper.slideToLoop(index);
    });
  });

  prevArrow.addEventListener('click', () => {
    swiper.slidePrev();
  });

  nextArrow.addEventListener('click', () => {
    swiper.slideNext();
  });
});
